export const APP_AUTH_PAGES: readonly string[] = ['/login', '/game', '/forgot'];

export const whiteList: readonly string[] = ['/login/', '/signup/', '/forgot/'];

export type FooterPage = {
    name: string;
    url: string;
    iconClass: string;
    textClass: string;
    nodeId: string;
}
export const FOOTER_PAGES: readonly FooterPage[] = [
    {
        name: "STORE",
        url: "store",
        iconClass: "s-shop-cart",
        textClass: "s-font-store",
        nodeId: "store",
    },
    {
        name: "REDEEM",
        url: "redeem",
        iconClass: "s-wallet",
        textClass: "s-font-redeem",
        nodeId: "guideStep3",
    },
    {
        name: "HOME",
        url: "/",
        iconClass: "s-home",
        textClass: "s-font-home",
        nodeId: "home",
    },
    {
        name: "REWARDS",
        url: "rewards",
        iconClass: "s-rewards",
        textClass: "s-font-rewards",
        nodeId: "guideStep4",
    },
    {
        name: "ACCOUNT",
        url: "account",
        iconClass: "s-collect",
        textClass: "s-font-account",
        nodeId: "guideStep5",
    },
    // {
    //     name: "ACCOUNT",
    //     url: "personal",
    //     iconClass: "s-collect",
    //     textClass: "s-font-account",
    //     nodeId: "guideStep5",
    // }
]

export const isActiveTab = (targetRoute: string, pathname: string) => {
    const currentPath = pathname;

    if (targetRoute === "/") {
        return currentPath === targetRoute; // 主页精确匹配
    }


    if (targetRoute + '/' === currentPath || currentPath.split('/').includes(targetRoute)) {
        return true;
    }

    return currentPath === targetRoute; // 其他路径匹配
};

export const HashMapPathName = (arr: readonly FooterPage[], pathname: string) => {
    for (const arrKey in arr) {
        const row = arr[arrKey];
        if (isActiveTab(row.url, pathname)) {
            return true;
        }
    }
    return false;
};
